import { render } from "./SeparateContent.vue?vue&type=template&id=61e5929c&scoped=true"
import script from "./SeparateContent.vue?vue&type=script&lang=js"
export * from "./SeparateContent.vue?vue&type=script&lang=js"

import "./SeparateContent.vue?vue&type=style&index=0&id=61e5929c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e5929c"]])

export default __exports__